(function() {
  // Add custom code below this line

  var links = document.links;

  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest('.pdp-post-atc-banner-block__copy');

    if (!button) return;

    event.preventDefault();

    const textToCopy = button.dataset.copyText;

    if (!textToCopy) return;

    navigator.clipboard.writeText(textToCopy).then(function() {
      button.classList.add('is-copied');

      setTimeout(function() {
        button.classList.remove('is-copied');
      }, 2000);
    });
  });

})();